<template>
  <v-container>
    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary">Fiche Laverie {{ laverie.numeroDeContrat }}</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-card class="mb-4">
            <v-card-text>
              <v-text-field v-model="laverie.name" label="Nom" density="compact" />
              <v-text-field v-model="laverie.fullAddress" label="Adresse" density="compact" />
              <v-text-field v-model="laverie.telephonePrincipal" label="Contact principal" density="compact" />
              <v-text-field v-model="laverie.telephoneAutre" label="Contact secondaire" density="compact" />
              <v-text-field v-model="laverie.codeAcces" label="Code d'accès" density="compact" />
            </v-card-text>
          </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="!isInterventionStarted" class="d-flex justify-center mb-4">
      <v-btn color="primary" class="text-white" min-width="120" @click="startIntervention()">
        Démarrer l'intervention
      </v-btn>
    </div>

    <!-- ACTIVITE -->
    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel :disabled="!isInterventionStarted">
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary">Activité</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-card class="mb-4">
            <v-card-text>
              <v-text-field label="Type d'activité" v-model="task.taskType" readonly />

              <v-select label="Statut" :items="statusItems" v-model="task.taskStatus" />
              <v-textarea label="Description" v-model="task.subject" />
            </v-card-text>
          </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- PRODTUIS -->
    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel :disabled="!isInterventionStarted">
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary">Produits</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-expansion-panels multiple>
            <v-expansion-panel :disabled="!isInterventionStarted" v-for="product in productsWithIntervention"
              :key="product.id">
              <!-- PRODUCT HEADER -->
              <v-expansion-panel-title>
                <div class="d-flex align-center ga-2">
                  <span>{{ product.aquaNb }} – {{ product.productType }} – {{ product.productMake }}</span>
                  <v-chip v-if="(pannesPerProduct[product.id] || []).some(pan => pan.id && !pan.repaired)" size="small"
                    color="red" class="text-white">
                    Panne en attente de réparation
                  </v-chip>
                </div>
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-tabs v-model="productTabs[product.id]" color="primary" class="mb-4">
                  <v-tab v-if="task.taskType === 'CAISSE_ET_MAINTENANCE' || task.taskType === 'LOCATION_MAINTENANCE'"
                    value="intervention">Intervention</v-tab>
                  <v-tab value="pannes">Pannes</v-tab>
                  <v-tab value="ticket-panne">Ticket Panne</v-tab>
                </v-tabs>

                <v-window v-model="productTabs[product.id]">
                  <v-window-item
                    v-if="task.taskType === 'CAISSE_ET_MAINTENANCE' || task.taskType === 'LOCATION_MAINTENANCE'"
                    value="intervention">
                    <div v-if="getIntervention(product.id)" class="mb-6 pt-4">
                      <!-- CHECKLIST ITEMS -->
                      <div v-for="item in getIntervention(product.id).items" :key="item.id">
                        <!-- CHECKBOX -->
                        <v-checkbox v-if="item.itemType === 'CHECKBOX'" v-model="item.completed" :label="item.label"
                          hide-details />

                        <!-- NUMERIC -->
                        <v-text-field v-if="item.itemType === 'NUMERIC'" type="number" :label="item.label"
                          v-model="item.numericValue" density="comfortable" />

                        <!-- TEXT -->
                        <v-textarea v-if="item.itemType === 'TEXT'" :label="item.label" v-model="item.textValue"
                          auto-grow />
                      </div>

                      <v-text-field label="Commentaire" v-model="getIntervention(product.id).comment"
                        density="comfortable" />

                      <v-divider class="my-4" />

                      <div class="d-flex justify-center my-3">
                        <v-btn color="primary" class="text-white" min-width="140"
                          @click="completeIntervention(getIntervention(product.id))">
                          Terminer pour ce produit
                        </v-btn>
                      </div>
                    </div>
                  </v-window-item>

                  <v-window-item value="pannes">
                    <!-- PANNES -->
                    <v-expansion-panels variant="accordion" v-model="openedPanneIndex[product.id]">
                      <v-expansion-panel v-for="(panne, i) in pannesPerProduct[product.id] || []" :key="panne.id ?? i"
                        :value="i" :class="{ 'opacity-50': panne.repaired }">
                        <!-- PANNE HEADER -->
                        <v-expansion-panel-title @click="ensurePanneThumbnailsLoaded(panne)">
                          <div class="d-flex align-center justify-space-between w-100">
                            <span>{{ panne.name || "Nouvelle panne" }}</span>
                          </div>
                        </v-expansion-panel-title>

                        <!-- PANNE BODY -->
                        <v-expansion-panel-text>
                          <v-text-field label="Titre" v-model="panne.name" density="compact"
                            :disabled="panne.repaired" />

                          <v-textarea label="Description panne" v-model="panne.desc" :disabled="panne.repaired"
                            auto-grow rows="3" />
                          <div class="d-flex flex-wrap ga-4">
                            <v-checkbox v-model="panne.repaired" label="Réparée" density="compact" hide-details />
                          </div>
                          <v-divider class="mt-4 mb-6" />

                          <v-row class="mb-2" density="compact">
                            <v-col cols="12" md="6" class="d-flex flex-column align-center">
                              <div class="text-subtitle-2 mb-2">Photo avant réparation</div>
                              <div class="d-flex ga-2 mb-2 justify-center">
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-paperclip"
                                  :disabled="panne.repaired || !panne.id"
                                  @click="triggerPanneFileInput(`panne-before-input-${product.id}-${panne.id ?? i}`)">
                                  Attacher
                                </v-btn>
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-camera"
                                  :disabled="panne.repaired || !panne.id || !isBrowserCameraAvailable"
                                  @click="openPanneCamera(panne, VaultFileTag.BEFORE)">
                                  Caméra
                                </v-btn>
                              </div>
                              <input :id="`panne-before-input-${product.id}-${panne.id ?? i}`" type="file"
                                accept="image/*" class="d-none"
                                @change="onPanneFileSelected($event, panne, VaultFileTag.BEFORE)" />
                              <div class="panne-thumbnail-wrapper mt-2">
                                <v-img v-if="panne.id && pannePhotoBeforeUrls[panne.id]"
                                  :src="pannePhotoBeforeUrls[panne.id]" class="rounded panne-thumbnail"
                                  @click="openPannePhoto(panne.id, VaultFileTag.BEFORE)" />
                              </div>
                              <v-btn v-if="panne.id && pannePhotoBeforeUrls[panne.id]" size="x-small" variant="text"
                                color="primary" prepend-icon="mdi-download" class="mt-1"
                                @click="downloadPannePhoto(panne.id, VaultFileTag.BEFORE)">
                                Télécharger
                              </v-btn>
                            </v-col>

                            <v-col cols="12" md="6" class="d-flex flex-column align-center">
                              <div class="text-subtitle-2 mb-2">Photo après réparation</div>
                              <div class="d-flex ga-2 mb-2 justify-center">
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-paperclip"
                                  :disabled="panne.repaired || !panne.id"
                                  @click="triggerPanneFileInput(`panne-after-input-${product.id}-${panne.id ?? i}`)">
                                  Attacher
                                </v-btn>
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-camera"
                                  :disabled="panne.repaired || !panne.id || !isBrowserCameraAvailable"
                                  @click="openPanneCamera(panne, VaultFileTag.AFTER)">
                                  Caméra
                                </v-btn>
                              </div>
                              <input :id="`panne-after-input-${product.id}-${panne.id ?? i}`" type="file"
                                accept="image/*" class="d-none"
                                @change="onPanneFileSelected($event, panne, VaultFileTag.AFTER)" />
                              <div class="panne-thumbnail-wrapper mt-2">
                                <v-img v-if="panne.id && pannePhotoAfterUrls[panne.id]"
                                  :src="pannePhotoAfterUrls[panne.id]" class="rounded panne-thumbnail"
                                  @click="openPannePhoto(panne.id, VaultFileTag.AFTER)" />
                              </div>
                              <v-btn v-if="panne.id && pannePhotoAfterUrls[panne.id]" size="x-small" variant="text"
                                color="primary" prepend-icon="mdi-download" class="mt-1"
                                @click="downloadPannePhoto(panne.id, VaultFileTag.AFTER)">
                                Télécharger
                              </v-btn>
                            </v-col>
                          </v-row>

                          <v-divider class="my-4" />

                          <!-- INSTALLED SPAREPARTS -->
                          <div v-for="(installedSparepart, j) in panne.installedSpareParts || []" :key="j"
                            class="mb-2 d-flex ga-3 align-center">
                            <div style="width: 75%" :class="{
                              'red-outline-wrapper': installedSparepart.sparepartId && !isSparePartAvailable(installedSparepart.sparepartId),
                              'green-outline-wrapper': installedSparepart.sparepartId && isSparePartAvailable(installedSparepart.sparepartId)
                            }">
                              <v-autocomplete :label="getSparePartLabel(installedSparepart.sparepartId)"
                                :items="spareparts" v-model="installedSparepart.sparepartId" item-title="displayName"
                                item-value="id" :disabled="panne.repaired" />
                            </div>

                            <v-text-field style="width: 25%" type="number" label="Quantité"
                              v-model="installedSparepart.quantity" :disabled="panne.repaired" />
                          </div>

                          <!-- ADD INSTALLED SPAREPART -->
                          <div class="d-flex justify-end mt-2">
                            <v-btn size="small" variant="outlined" color="primary" :disabled="panne.repaired"
                              @click="addInstalledSparepart(panne)">
                              Ajouter pièce détachée
                            </v-btn>
                          </div>

                          <div class="d-flex justify-center mt-4">
                            <v-btn color="primary" class="text-white" min-width="120"
                              @click="submitPanne(product, panne)">
                              Mettre à jour la Panne
                            </v-btn>

                            <v-spacer style="max-width: 16px" />

                            <v-btn color="error" class="text-white" min-width="120" @click="removePanne(product, i)">
                              {{ isPendingPanne(panne) ? "Annuler Panne" : "Supprimer Panne" }}
                            </v-btn>
                          </div>
                        </v-expansion-panel-text>
                      </v-expansion-panel>
                    </v-expansion-panels>

                    <div v-if="(pannesPerProduct[product.id] || []).length === 0"
                      class="text-center text-medium-emphasis mt-4">
                      Aucune panne enregistrée pour ce produit.
                    </div>
                  </v-window-item>

                  <v-window-item value="ticket-panne">
                    <v-card variant="outlined" class="pa-4">
                      <div class="d-flex justify-space-between align-center mb-2">
                        <v-card-title class="px-0 pt-0 pb-0">Tickets panne ouverts</v-card-title>
                        <v-btn color="primary" class="text-white" @click="startCreateTicketPanne(product)">
                          Nouveau ticket
                        </v-btn>
                      </div>

                      <v-card-text class="px-0">
                        <v-progress-linear v-if="ticketPanneLoading[product.id]" indeterminate color="primary"
                          class="mb-4" />

                        <v-list v-else-if="(openTicketPannesPerProduct[product.id] || []).length > 0" lines="two"
                          density="compact" class="mb-4">
                          <template
                            v-for="(ticket, index) in openTicketPannesPerProduct[product.id]"
                            :key="ticket.id"
                          >
                          <v-list-item>
                            <v-list-item-title>
                              {{ ticket.title || (ticket.id ? `Ticket ${ticket.id}` : 'Ticket ouvert') }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ ticket.id ? `#${ticket.id} - ` : '' }}{{ ticket.description || 'Sans description' }}
                            </v-list-item-subtitle>

                            <div v-if="ticket.id && ticketPhotoBeforeUrls[ticket.id]" class="ticket-thumbnail-wrapper mt-2">
                              <v-img
                                :src="ticketPhotoBeforeUrls[ticket.id]"
                                class="rounded ticket-thumbnail"
                                @click="openTicketPhoto(ticket.id, VaultFileTag.BEFORE)"
                              />
                            </div>

                            <v-btn
                              v-if="ticket.id && ticketPhotoBeforeUrls[ticket.id]"
                              size="x-small"
                              variant="text"
                              color="primary"
                              prepend-icon="mdi-download"
                              class="mt-1"
                              @click="downloadTicketPhoto(ticket.id, VaultFileTag.BEFORE)"
                            >
                              Télécharger photo
                            </v-btn>

                            <template #append>
                              <v-btn size="small" variant="text" color="primary" prepend-icon="mdi-pencil"
                                @click="startEditTicketPanne(product, ticket)">
                                Modifier
                              </v-btn>
                            </template>
                          </v-list-item>
                          <v-divider
                            v-if="index < openTicketPannesPerProduct[product.id].length - 1"
                            color="grey-lighten"
                            class="my-2"
                          />
                          </template>
                        </v-list>

                        <div v-else class="text-center text-medium-emphasis mb-4">
                          Aucun ticket panne ouvert pour ce produit.
                        </div>

                        <div class="d-flex justify-end mb-2">
                          <v-btn variant="text" color="primary" @click="loadOpenTicketPannes(product.id)">
                            Rafraîchir
                          </v-btn>
                        </div>

                        <v-expand-transition>
                          <div v-if="ticketPanneCreateVisible[product.id] && ticketPanneForms[product.id]">
                            <v-divider class="my-4" />
                            <div class="text-subtitle-1 mb-3">
                              {{ ticketPanneEditingId[product.id] ? 'Modifier un ticket panne' : 'Créer un ticket panne'
                              }}
                            </div>

                            <v-row dense>
                              <v-col cols="12">
                                <v-text-field v-model="ticketPanneForms[product.id].title" label="Titre"
                                  density="compact" />
                              </v-col>
                              <v-col cols="12" md="6">
                                <v-text-field :model-value="laverie.name" label="Laverie" readonly density="compact" />
                              </v-col>

                              <v-col cols="12" md="6">
                                <v-text-field
                                  :model-value="`${product.aquaNb} – ${product.productType} – ${product.productMake}`"
                                  label="Produit concerné" readonly density="compact" />
                              </v-col>

                              <v-col cols="12">
                                <v-textarea v-model="ticketPanneForms[product.id].description"
                                  label="Description de la panne" rows="4" auto-grow />
                              </v-col>
                            </v-row>



                            <v-col cols="12" md="6" class="d-flex flex-column align-center">
                              <div class="text-subtitle-2 mb-2">Photo de la panne</div>
                              <div class="d-flex ga-2 mb-2 justify-center">
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-paperclip"
                                  @click="triggerTicketFileInput(`ticket-before-input-${product.id}-${ticketPanneForms[product.id].id}`)">
                                  Attacher
                                </v-btn>
                                <v-btn size="small" variant="outlined" color="primary" prepend-icon="mdi-camera"
                                  :disabled="!isBrowserCameraAvailable"
                                  @click="openTicketCamera(ticketPanneForms[product.id], VaultFileTag.BEFORE)">
                                  Caméra
                                </v-btn>
                              </div>
                              <input :id="`ticket-before-input-${product.id}-${ticketPanneForms[product.id].id}`" type="file"
                                accept="image/*" class="d-none"
                                @change="onTicketFileSelected($event, ticketPanneForms[product.id], VaultFileTag.BEFORE)" />
                              <div class="ticket-thumbnail-wrapper mt-2">
                                <v-img v-if="ticketPanneForms[product.id].id && ticketPhotoBeforeUrls[ticketPanneForms[product.id].id]"
                                  :src="ticketPhotoBeforeUrls[ticketPanneForms[product.id].id]" class="rounded ticket-thumbnail"
                                  @click="openTicketPhoto(ticketPanneForms[product.id].id, VaultFileTag.BEFORE)" />
                              </div>
                              <v-btn v-if="ticketPanneForms[product.id].id && ticketPhotoBeforeUrls[ticketPanneForms[product.id].id]" size="x-small" variant="text"
                                color="primary" prepend-icon="mdi-download" class="mt-1"
                                @click="downloadTicketPhoto(ticketPanneForms[product.id].id, VaultFileTag.BEFORE)">
                                Télécharger
                              </v-btn>
                            </v-col>



                            <div class="d-flex justify-end ga-2">
                              <v-btn variant="outlined" color="primary" @click="cancelCreateTicketPanne(product)">
                                Annuler
                              </v-btn>
                              <v-btn color="primary" class="text-white" :loading="ticketPanneSubmitting[product.id]"
                                @click="submitTicketPanne(product)">
                                {{ ticketPanneEditingId[product.id] ? 'Mettre à jour le ticket' : 'Soumettre le ticket'
                                }}
                              </v-btn>
                            </div>
                          </div>
                        </v-expand-transition>
                      </v-card-text>
                    </v-card>
                  </v-window-item>
                </v-window>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- TACHES -->
    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel :disabled="!isInterventionStarted">
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary">Tâches</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <SubtaskList :subtasks="task.subtasks || []" :show-title="false" :show-outline="false" @remove="removeSubtask"
            @update="updateSubtask" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- OBSERVATION -->
    <v-expansion-panels variant="accordion" class="mb-4">
      <v-expansion-panel :disabled="!isInterventionStarted">
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary">Observation</span>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-textarea class="mt-4" v-model="task.observation" />
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <div v-if="!isInterventionEnded && isInterventionStarted" class="d-flex justify-center mb-4">
      <v-btn color="primary" class="text-white" min-width="120" @click="endIntervention()">
        Terminer l'intervention
      </v-btn>
    </div>

    <!-- SIGNATURE -->
    <v-expansion-panels :disabled="!isInterventionEnded" variant="accordion" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <span class="text-h6 font-weight-medium text-primary"> Signature client </span>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-card variant="outlined" rounded="lg" class="pa-4">
            <div class="d-flex justify-center mb-4">
              <SignaturePad v-if="!signatureFile" ref="signature" />

              <v-img v-else :src="signatureUrl" max-width="400" max-height="400" />
            </div>

            <div v-if="!signatureFile" class="d-flex justify-end">
              <v-btn variant="outlined" class="mr-2" @click="clearSignature">
                Annuler
              </v-btn>

              <v-btn color="primary" class="text-white" :disabled="showProgressBar" @click="saveSignature">
                Enregistrer
              </v-btn>
            </div>
          </v-card>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- ACTIONS -->
    <v-row v-if="laverie.email" class="mt-6">
      <v-col>
        <v-btn :disabled="!isInterventionEnded" color="success" block @click="sendEmail">
          Envoyer email
        </v-btn>
      </v-col>
    </v-row>
    <UploadProgress :visible="showProgressBar" :file-name="progressInfo.fileName"
      :percentage="progressInfo.percentage" />

    <v-dialog v-model="isTicketCameraDialogOpen" max-width="900">
      <v-card>
        <v-card-title>
          {{ ticketCameraTarget?.tag === VaultFileTag.BEFORE ? "Photo avant réparation" : "Photo après réparation" }}
        </v-card-title>
        <v-card-text>
          <CameraComponent v-if="isTicketCameraDialogOpen" :auto-start="true"
            @photo-confirmed="onTicketCameraPhotoConfirmed" />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="closeTicketCamera">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script setup lang="ts">
import { useAppStore } from "@/store";
import { Intervention, InterventionItemType, Panne, Product, ProgressInfo, RefEntityType, SparePart, Subtask, SupportTicket, SupportTicketCallerType, SupportTicketConcernedService, SupportTicketContactType, SupportTicketStatus, SupportTicketType, VaultFileTag, VaultFileType, Vehicle, VehicleInventoryItem } from "@/types";
import { Laverie } from "@/types";
import { Task } from "@/types";
import { fetchFileContent, fetchThumbnail, fetchVaultFiles, uploadPannePhoto, uploadTaskSignature, uploadTicketPhoto } from "@/utils/vault-file-api";
import { getLaverieById } from "@/utils/laverie-api";
import { getProductsByLaverieId } from "@/utils/product-api";
import { getTaskById, sendReport, setEndDateTime, setStartDateTime } from "@/utils/task-api";
import { AxiosProgressEvent } from "axios";
import { ref, onBeforeUnmount, onMounted, computed } from "vue";
import { useRoute } from "vue-router";
import SignaturePad from "vue3-signature";
import { VaultFile } from "@/types/vault-file";
import UploadProgress from "@/components/UploadProgress.vue";
import SubtaskList from "@/components/SubtaskList.vue";
import CameraComponent from "@/components/CameraComponent.vue";
import { fetchInterventionsByTaskId, putIntervention } from "@/utils/intervention-api";
import { deletePanne, getPannesByProduct, putPanne } from "@/utils/panne-api";
import { getVehicleByTaskListId, getVehicleInventoryItems } from "@/utils/vehicle-api";
import { getAllSpareparts } from "@/utils/sparepart-api";
import { deleteSupportTicket, fetchSupportTickets, postSupportTicket, putSupportTicket } from "@/utils/support-ticket-api";
import { useSessionStore } from "@/store/session";

const statusItems = ["En cours", "Terminé", "Reporté"];


const route = useRoute();
const appStore = useAppStore();
const sessionStore = useSessionStore();

const task = ref<Task>({} as Task);
const laverie = ref<Laverie>({} as Laverie);
const vehicle = ref<Vehicle>({} as Vehicle);
const products = ref<Array<Product>>([]);
const spareparts = ref<Array<SparePart>>([]);
const interventions = ref<Array<Intervention>>([]);
const pannesPerProduct = ref<Record<string, Panne[]>>({});
const productTabs = ref<Record<string, string>>({});
const openedPanneIndex = ref<Record<string, number | null>>({});
const pendingPanneIds = ref<Record<string, boolean>>({});
const ticketPanneForms = ref<Record<string, TicketPanneForm>>({});
const ticketPanneSubmitting = ref<Record<string, boolean>>({});
const openTicketPannesPerProduct = ref<Record<string, SupportTicket[]>>({});
const ticketPanneLoading = ref<Record<string, boolean>>({});
const ticketPanneCreateVisible = ref<Record<string, boolean>>({});
const ticketPanneEditingId = ref<Record<string, string | null>>({});
const showProgressBar = ref(false);
const vehicleInventoryItems = ref<VehicleInventoryItem[]>([]);
const ticketPhotoBeforeUrls = ref<Record<string, string>>({});
const ticketPhotoAfterUrls = ref<Record<string, string>>({});
const ticketPhotoBeforeFileIds = ref<Record<string, string>>({});
const ticketPhotoAfterFileIds = ref<Record<string, string>>({});
const pannePhotoBeforeUrls = ref<Record<string, string>>({});
const pannePhotoAfterUrls = ref<Record<string, string>>({});
const pannePhotoBeforeFileIds = ref<Record<string, string>>({});
const pannePhotoAfterFileIds = ref<Record<string, string>>({});
const loadedPanneThumbnailIds = ref<Record<string, boolean>>({});
const loadedTicketThumbnailIds = ref<Record<string, boolean>>({});
const isPanneCameraDialogOpen = ref(false);
const isTicketCameraDialogOpen = ref(false);
const panneCameraTarget = ref<{ panneId: string; tag: VaultFileTag } | null>(null);
const ticketCameraTarget = ref<{ ticketId: string; tag: VaultFileTag } | null>(null);
const isBrowserCameraAvailable = typeof navigator !== "undefined" && !!navigator.mediaDevices?.getUserMedia;

interface TicketPanneForm extends SupportTicket {
  assigneeName: string;
  ticketStatusLabel: string;
  ticketTypeLabel: string;
}

const progressInfo = ref<ProgressInfo>({
  fileName: "",
  percentage: 0,
});

const signature = ref(null);
const signatureFile = ref<VaultFile | null>(null);
const signatureUrl = ref(null);

const isInterventionStarted = computed(() => {
  return task.value && task.value.startDateTime ? true : false;
});

const isInterventionEnded = computed(() => {
  return task.value && task.value.endDateTime ? true : false;
});

const productsWithIntervention = computed(() => {
  return products.value.filter((product) =>
    interventions.value.some((intervention) => intervention.productId === product.id)
  );
});

function isSparePartAvailable(sparepartId: string): boolean {
  if (!sparepartId) {
    return false;
  }
  const inventoryItem = vehicleInventoryItems.value.find(
    (item) => item.sparepartId === sparepartId
  );
  return !!inventoryItem && inventoryItem.quantity > 0;
}

function getSparePartLabel(sparepartId: string): string {
  if (!sparepartId) {
    return "Pièce détachée";
  }
  return isSparePartAvailable(sparepartId)
    ? "Pièce détachée (Disponible en véhicule)"
    : "Pièce détachée (Indisponible en véhicule)";
}

onMounted(async () => {
  if (!route.params.id) {
    return;
  }

  task.value = await getTaskById(route.params.id as string);
  task.value.subtasks ||= [];
  laverie.value = await getLaverieById(task.value.laverieId);
  products.value = await getProductsByLaverieId(laverie.value.id);
  interventions.value = await fetchInterventionsByTaskId(task.value.id);
  spareparts.value = await getAllSpareparts();

  products.value.forEach((product) => {
    productTabs.value[product.id] = "intervention";
    ticketPanneForms.value[product.id] = buildTicketPanneForm(product);
  });

  await Promise.all(
    productsWithIntervention.value.map((product) => loadOpenTicketPannes(product.id))
  );

  vehicle.value = await getVehicleByTaskListId(task.value.taskListId);
  if (vehicle.value) {
    vehicleInventoryItems.value = await getVehicleInventoryItems(vehicle.value.id);
  } else {
    appStore.sendErrorNotice("Véhicule associé à la tâche introuvable. Les pièces détachées ne seront pas affichées.");
  }

  const panneResults = await Promise.all(
    productsWithIntervention.value.map((product) =>
      getPannesByProduct(product.id, false).then((pannes) => ({ productId: product.id, pannes }))
    )
  );

  panneResults.forEach(({ productId, pannes }) => {
    pannesPerProduct.value[productId] = pannes;
  });

  await Promise.all(
    panneResults.flatMap(({ pannes }) =>
      pannes
        .filter((panne) => !!panne.id)
        .map((panne) => loadPanneThumbnails(panne.id as string))
    )
  );

  const files = await fetchVaultFiles({
    refEntityType: RefEntityType.TASK,
    refEntityId: task.value.id,
    type: VaultFileType.SIGNATURE,
  });

  signatureFile.value = files[0] ?? null;
  if (signatureFile.value) {
    await loadSignature(signatureFile.value.id);
  }
});

function buildTicketPanneForm(product: Product): TicketPanneForm {
  const connectedUser = sessionStore.loggedUser;
  const callerName = connectedUser?.fullName || connectedUser?.username || "";

  return {
    title: "",
    laverieId: laverie.value.id,
    productId: product.id,
    productType: product.productType,
    ticketType: SupportTicketType.TECHNICAL_ISSUE,
    ticketStatus: SupportTicketStatus.OPEN,
    callerType: SupportTicketCallerType.TECHNICIAN,
    contactType: SupportTicketContactType.TOURNEE,
    concernedService: SupportTicketConcernedService.TECHNICAL,
    caller: callerName,
    telephone: connectedUser?.telephone || "",
    email: connectedUser?.email || "",
    description: "",
    assigneeId: connectedUser?.id,
    creatorId: connectedUser?.id,
    assigneeName: connectedUser?.fullName || connectedUser?.username || "",
    ticketStatusLabel: "Ouvert",
    ticketTypeLabel: "Problème technique"
  };
}

async function startCreateTicketPanne(product: Product): Promise<void> {
  const form = buildTicketPanneForm(product);
  ticketPanneSubmitting.value[product.id] = true;
  try {
    const { assigneeName, ticketStatusLabel, ticketTypeLabel, ...payload } = form;
    const created = await postSupportTicket({
      ...payload,
      laverieId: laverie.value.id,
      productId: product.id,
      productType: product.productType,
      creatorId: sessionStore.loggedUser?.id,
      assigneeId: sessionStore.loggedUser?.id,
      ticketType: SupportTicketType.TECHNICAL_ISSUE,
      ticketStatus: SupportTicketStatus.OPEN,
      callerType: SupportTicketCallerType.TECHNICIAN,
      contactType: SupportTicketContactType.TOURNEE,
      concernedService: SupportTicketConcernedService.TECHNICAL,
    });
    ticketPanneForms.value[product.id] = { ...form, ...created, assigneeName: form.assigneeName, ticketStatusLabel: form.ticketStatusLabel, ticketTypeLabel: form.ticketTypeLabel };
    ticketPanneEditingId.value[product.id] = created.id ?? null;
    ticketPanneCreateVisible.value[product.id] = true;
    await loadOpenTicketPannes(product.id);
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    ticketPanneSubmitting.value[product.id] = false;
  }
}

async function cancelCreateTicketPanne(product: Product): Promise<void> {
  const ticketId = ticketPanneEditingId.value[product.id];
  if (ticketId) {
    try {
      await deleteSupportTicket(ticketId);
      await loadOpenTicketPannes(product.id);
    } catch (e) {
      // Ignore because it's handled in axios service
    }
  }
  ticketPanneForms.value[product.id] = buildTicketPanneForm(product);
  ticketPanneEditingId.value[product.id] = null;
  ticketPanneCreateVisible.value[product.id] = false;
}

function buildTicketPanneFormFromTicket(product: Product, ticket: SupportTicket): TicketPanneForm {
  const connectedUser = sessionStore.loggedUser;
  return {
    ...buildTicketPanneForm(product),
    ...ticket,
    productId: product.id,
    productType: product.productType,
    ticketStatusLabel: ticket.ticketStatus === SupportTicketStatus.OPEN ? "Ouvert" : String(ticket.ticketStatus || ""),
    ticketTypeLabel: ticket.ticketType === SupportTicketType.TECHNICAL_ISSUE ? "Problème technique" : String(ticket.ticketType || ""),
    assigneeName: connectedUser?.fullName || connectedUser?.username || "",
  };
}

function startEditTicketPanne(product: Product, ticket: SupportTicket): void {
  if (!ticket.id) {
    appStore.sendWarningNotice("Impossible de modifier ce ticket.");
    return;
  }

  ticketPanneForms.value[product.id] = buildTicketPanneFormFromTicket(product, ticket);
  ticketPanneEditingId.value[product.id] = ticket.id;
  ticketPanneCreateVisible.value[product.id] = true;
}

async function loadOpenTicketPannes(productId: string): Promise<void> {
  ticketPanneLoading.value[productId] = true;
  try {
    const tickets = await fetchSupportTickets(
      [SupportTicketType.TECHNICAL_ISSUE],
      [SupportTicketStatus.OPEN],
      productId
    );
    openTicketPannesPerProduct.value[productId] = tickets;

    await Promise.all(
      tickets
        .filter((ticket) => !!ticket.id)
        .map((ticket) => loadTicketThumbnails(ticket.id as string))
    );
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    ticketPanneLoading.value[productId] = false;
  }
}

async function startIntervention() {
  try {
    task.value.startDateTime = new Date();
    await setStartDateTime(task.value.id, task.value.startDateTime);
    task.value = await getTaskById(task.value.id);
    interventions.value = await fetchInterventionsByTaskId(task.value.id);
  } catch (e) {
    task.value.startDateTime = null;
  }
}

async function endIntervention() {
  try {
    task.value.endDateTime = new Date();
    await setEndDateTime(task.value.id, task.value.endDateTime);
    task.value = await getTaskById(task.value.id);
  } catch (e) {
    task.value.endDateTime = null;
  }
}

function clearSignature() {
  signature.value?.clear?.();
}

async function saveSignature() {
  if (!signature.value || signature.value.isEmpty()) {
    return;
  }

  showProgressBar.value = true;
  progressInfo.value.fileName = "signature.png";
  progressInfo.value.percentage = 0;

  try {
    const response = await uploadTaskSignature(
      signature.value.toDataURL("image/png"),
      task.value.id,
      (event: AxiosProgressEvent) => {
        if (event.progress !== undefined) {
          progressInfo.value.percentage = Math.round(event.progress * 100);
        }
      }
    );
    signatureFile.value = response.data;
    if (signatureFile.value) {
      await loadSignature(signatureFile.value.id);
    }
    appStore.sendSuccessNotice("Signature enregistrée avec succès");
  } catch (e) {
    // Ignore
  } finally {
    showProgressBar.value = false;
  }
}

async function loadSignature(fileId: string) {
  signatureUrl.value = await fetchFileContent(fileId);
}

async function submitTicketPanne(product: Product): Promise<void> {
  const form = ticketPanneForms.value[product.id] || buildTicketPanneForm(product);
  if (!form.description.trim()) {
    appStore.sendWarningNotice("Veuillez saisir une description pour le ticket panne.");
    return;
  }

  ticketPanneSubmitting.value[product.id] = true;
  try {
    const { assigneeName, ticketStatusLabel, ticketTypeLabel, ...payload } = form;
    const editingId = ticketPanneEditingId.value[product.id];

    if (!editingId) {
      appStore.sendWarningNotice("Ticket introuvable.");
      return;
    }

    await putSupportTicket(editingId, {
      ...payload,
      laverieId: laverie.value.id,
      productId: product.id,
      productType: product.productType,
    });
    appStore.sendSuccessNotice("Ticket panne mis à jour avec succès.");

    ticketPanneForms.value[product.id] = buildTicketPanneForm(product);
    ticketPanneEditingId.value[product.id] = null;
    ticketPanneCreateVisible.value[product.id] = false;
    await loadOpenTicketPannes(product.id);
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    ticketPanneSubmitting.value[product.id] = false;
  }
}

async function removePanne(product: Product, panneIndex: number): Promise<void> {
  const panne = pannesPerProduct.value[product.id]?.[panneIndex];

  try {
    if (panne?.id) {
      await deletePanne(panne.id);
      delete pendingPanneIds.value[panne.id];
    }

    pannesPerProduct.value[product.id].splice(panneIndex, 1);
    openedPanneIndex.value[product.id] = null;
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}

async function submitPanne(product: Product, panne: Panne): Promise<void> {
  // Ensure the panne has the correct vehicleId before submitting to update the vehicle inventory based on the installed spareparts
  panne.vehicleId = vehicle.value.id;
  try {
    await putPanne(panne);
    if (panne.id) {
      delete pendingPanneIds.value[panne.id];
    }
    openedPanneIndex.value[product.id] = null;
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}

function triggerPanneFileInput(inputId: string): void {
  const input = document.getElementById(inputId) as HTMLInputElement | null;
  input?.click();
}

function triggerTicketFileInput(inputId: string): void {
  const input = document.getElementById(inputId) as HTMLInputElement | null;
  input?.click();
}

async function onPanneFileSelected(event: Event, panne: Panne, tag: VaultFileTag): Promise<void> {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) {
    return;
  }

  try {
    const dataUrl = await fileToDataUrl(file);
    await uploadPannePhotoFromDataUrl(dataUrl, panne, tag);
  } finally {
    target.value = "";
  }
}

async function onTicketFileSelected(event: Event, ticket: SupportTicket, tag: VaultFileTag): Promise<void> {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0];
  if (!file) {
    return;
  }

  try {
    const dataUrl = await fileToDataUrl(file);
    await uploadTicketPhotoFromDataUrl(dataUrl, ticket, tag);
  } finally {
    target.value = "";
  }
}

function openPanneCamera(panne: Panne, tag: VaultFileTag): void {
  if (!panne.id) {
    appStore.sendErrorNotice("Veuillez d'abord enregistrer la panne avant d'ajouter une photo.");
    return;
  }

  panneCameraTarget.value = { panneId: panne.id, tag };
  isPanneCameraDialogOpen.value = true;
}

function openTicketCamera(ticket: SupportTicket, tag: VaultFileTag): void {
  if (!ticket.id) {
    appStore.sendErrorNotice("Veuillez d'abord enregistrer le ticket avant d'ajouter une photo.");
    return;
  }

  ticketCameraTarget.value = { ticketId: ticket.id, tag };
  isTicketCameraDialogOpen.value = true;
}


function closeTicketCamera(): void {
  isTicketCameraDialogOpen.value = false;
  ticketCameraTarget.value = null;
}

async function onTicketCameraPhotoConfirmed(payload: { image?: string }): Promise<void> {
  const dataUrl = payload?.image;
  if (!dataUrl || !ticketCameraTarget.value) {
    return;
  }

  const target = ticketCameraTarget.value;
  const ticket = findTicketById(target.ticketId);
  if (!ticket) {
    appStore.sendErrorNotice("Ticket introuvable pour l'ajout de photo.");
    return;
  }

  await uploadTicketPhotoFromDataUrl(dataUrl, ticket, target.tag);
  closeTicketCamera();
}

async function uploadTicketPhotoFromDataUrl(dataUrl: string, ticket: SupportTicket, tag: VaultFileTag): Promise<void> {
  if (!ticket.id) {
    appStore.sendErrorNotice("Veuillez d'abord enregistrer le ticket avant d'ajouter une photo.");
    return;
  }

  showProgressBar.value = true;
  progressInfo.value.fileName = tag === VaultFileTag.BEFORE ? "photo-avant.png" : "photo-apres.png";
  progressInfo.value.percentage = 0;

  try {
    const response = await uploadTicketPhoto(
      dataUrl,
      ticket.id,
      (event: AxiosProgressEvent) => {
        if (event.progress !== undefined) {
          progressInfo.value.percentage = Math.round(event.progress * 100);
        }
      },
      tag
    );

    const uploadedFile = response?.data as VaultFile | undefined;
    if (uploadedFile?.id) {
      const thumbnailUrl = await fetchThumbnail(uploadedFile.id);
      setTicketThumbnail(ticket.id, tag, thumbnailUrl);
      setTicketPhotoFileId(ticket.id, tag, uploadedFile.id);
    } else {
      await loadTicketThumbnails(ticket.id);
    }

    appStore.sendSuccessNotice("Photo de ticket enregistrée avec succès.");
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    showProgressBar.value = false;
  }
}

async function uploadPannePhotoFromDataUrl(dataUrl: string, panne: Panne, tag: VaultFileTag): Promise<void> {
  if (!panne.id) {
    appStore.sendErrorNotice("Veuillez d'abord enregistrer la panne avant d'ajouter une photo.");
    return;
  }

  showProgressBar.value = true;
  progressInfo.value.fileName = tag === VaultFileTag.BEFORE ? "photo-avant.png" : "photo-apres.png";
  progressInfo.value.percentage = 0;

  try {
    const response = await uploadPannePhoto(
      dataUrl,
      panne.id,
      (event: AxiosProgressEvent) => {
        if (event.progress !== undefined) {
          progressInfo.value.percentage = Math.round(event.progress * 100);
        }
      },
      tag
    );

    const uploadedFile = response?.data as VaultFile | undefined;
    if (uploadedFile?.id) {
      const thumbnailUrl = await fetchThumbnail(uploadedFile.id);
      setPanneThumbnail(panne.id, tag, thumbnailUrl);
      setPannePhotoFileId(panne.id, tag, uploadedFile.id);
    } else {
      await loadPanneThumbnails(panne.id);
    }

    appStore.sendSuccessNotice("Photo de panne enregistrée avec succès.");
  } catch (e) {
    // Ignore because it's handled in axios service
  } finally {
    showProgressBar.value = false;
  }
}

async function loadPanneThumbnails(panneId: string): Promise<void> {
  try {
    const beforeTaggedFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.PANNE,
      refEntityId: panneId,
      type: VaultFileType.PHOTO,
      tag: VaultFileTag.BEFORE,
    }) as Array<Record<string, unknown>>;

    const afterTaggedFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.PANNE,
      refEntityId: panneId,
      type: VaultFileType.PHOTO,
      tag: VaultFileTag.AFTER,
    }) as Array<Record<string, unknown>>;

    const allFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.PANNE,
      refEntityId: panneId,
      type: VaultFileType.PHOTO,
    }) as Array<Record<string, unknown>>;

    const beforeFile = beforeTaggedFiles[0]
      ?? allFiles.find((file) => readVaultFileTag(file) === VaultFileTag.BEFORE)
      ?? allFiles.find((file) => !readVaultFileTag(file));

    const afterFile = afterTaggedFiles[0]
      ?? allFiles.find((file) => readVaultFileTag(file) === VaultFileTag.AFTER);

    const beforeFileId = readVaultFileId(beforeFile);
    const afterFileId = readVaultFileId(afterFile);

    if (beforeFileId) {
      const beforeThumbnail = await fetchThumbnail(beforeFileId);
      setPanneThumbnail(panneId, VaultFileTag.BEFORE, beforeThumbnail);
      setPannePhotoFileId(panneId, VaultFileTag.BEFORE, beforeFileId);
    }

    if (afterFileId) {
      const afterThumbnail = await fetchThumbnail(afterFileId);
      setPanneThumbnail(panneId, VaultFileTag.AFTER, afterThumbnail);
      setPannePhotoFileId(panneId, VaultFileTag.AFTER, afterFileId);
    }

    loadedPanneThumbnailIds.value[panneId] = true;
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}

async function loadTicketThumbnails(ticketId: string): Promise<void> {
  try {
    const beforeTaggedFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.SUPPORT_TICKET,
      refEntityId: ticketId,
      type: VaultFileType.PHOTO,
      tag: VaultFileTag.BEFORE,
    }) as Array<Record<string, unknown>>;

    const afterTaggedFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.SUPPORT_TICKET,
      refEntityId: ticketId,
      type: VaultFileType.PHOTO,
      tag: VaultFileTag.AFTER,
    }) as Array<Record<string, unknown>>;

    const allFiles = await fetchVaultFiles({
      refEntityType: RefEntityType.SUPPORT_TICKET,
      refEntityId: ticketId,
      type: VaultFileType.PHOTO,
    }) as Array<Record<string, unknown>>;

    const beforeFile = beforeTaggedFiles[0]
      ?? allFiles.find((file) => readVaultFileTag(file) === VaultFileTag.BEFORE)
      ?? allFiles.find((file) => !readVaultFileTag(file));

    const afterFile = afterTaggedFiles[0]
      ?? allFiles.find((file) => readVaultFileTag(file) === VaultFileTag.AFTER);

    const beforeFileId = readVaultFileId(beforeFile);
    const afterFileId = readVaultFileId(afterFile);

    if (beforeFileId) {
      const beforeThumbnail = await fetchThumbnail(beforeFileId);
      setTicketThumbnail(ticketId, VaultFileTag.BEFORE, beforeThumbnail);
      setTicketPhotoFileId(ticketId, VaultFileTag.BEFORE, beforeFileId);
    }

    if (afterFileId) {
      const afterThumbnail = await fetchThumbnail(afterFileId);
      setTicketThumbnail(ticketId, VaultFileTag.AFTER, afterThumbnail);
      setTicketPhotoFileId(ticketId, VaultFileTag.AFTER, afterFileId);
    }

    loadedTicketThumbnailIds.value[ticketId] = true;
  } catch (e) {
    // Ignore because it's handled in axios service
  }
}

async function ensurePanneThumbnailsLoaded(panne: Panne): Promise<void> {
  if (!panne.id || loadedPanneThumbnailIds.value[panne.id]) {
    return;
  }

  await loadPanneThumbnails(panne.id);
}

async function ensureTicketThumbnailsLoaded(ticket: SupportTicket): Promise<void> {
  if (!ticket.id || loadedTicketThumbnailIds.value[ticket.id]) {
    return;
  }

  await loadTicketThumbnails(ticket.id);
}

function readVaultFileId(file?: Record<string, unknown>): string | undefined {
  if (!file) {
    return undefined;
  }

  const rawId = file.id ?? file.fileId;
  return typeof rawId === "string" || typeof rawId === "number" ? String(rawId) : undefined;
}

function readVaultFileTag(file?: Record<string, unknown>): string | undefined {
  if (!file) {
    return undefined;
  }

  const rawTag = file.tag ?? file.fileTag;
  return typeof rawTag === "string" ? rawTag : undefined;
}

function setPanneThumbnail(panneId: string, tag: VaultFileTag, url: string): void {
  if (tag === VaultFileTag.BEFORE) {
    const previousUrl = pannePhotoBeforeUrls.value[panneId];
    if (previousUrl) {
      URL.revokeObjectURL(previousUrl);
    }
    pannePhotoBeforeUrls.value[panneId] = url;
    return;
  }

  const previousUrl = pannePhotoAfterUrls.value[panneId];
  if (previousUrl) {
    URL.revokeObjectURL(previousUrl);
  }
  pannePhotoAfterUrls.value[panneId] = url;
}

function setTicketThumbnail(ticketId: string, tag: VaultFileTag, url: string): void {
  if (tag === VaultFileTag.BEFORE) {
    const previousUrl = ticketPhotoBeforeUrls.value[ticketId];
    if (previousUrl) {
      URL.revokeObjectURL(previousUrl);
    }
    ticketPhotoBeforeUrls.value[ticketId] = url;
    return;
  }

  const previousUrl = ticketPhotoAfterUrls.value[ticketId];
  if (previousUrl) {
    URL.revokeObjectURL(previousUrl);
  }
  ticketPhotoAfterUrls.value[ticketId] = url;
}

function setPannePhotoFileId(panneId: string, tag: VaultFileTag, fileId: string): void {
  if (tag === VaultFileTag.BEFORE) {
    pannePhotoBeforeFileIds.value[panneId] = fileId;
    return;
  }

  pannePhotoAfterFileIds.value[panneId] = fileId;
}

function setTicketPhotoFileId(ticketId: string, tag: VaultFileTag, fileId: string): void {
  if (tag === VaultFileTag.BEFORE) {
    ticketPhotoBeforeFileIds.value[ticketId] = fileId;
    return;
  }

  ticketPhotoAfterFileIds.value[ticketId] = fileId;
}

function getPannePhotoFileId(panneId: string, tag: VaultFileTag): string | undefined {
  return tag === VaultFileTag.BEFORE
    ? pannePhotoBeforeFileIds.value[panneId]
    : pannePhotoAfterFileIds.value[panneId];
}

function getTicketPhotoFileId(ticketId: string, tag: VaultFileTag): string | undefined {
  return tag === VaultFileTag.BEFORE
    ? ticketPhotoBeforeFileIds.value[ticketId]
    : ticketPhotoAfterFileIds.value[ticketId];
}

async function openPannePhoto(panneId: string, tag: VaultFileTag): Promise<void> {
  const fileId = getPannePhotoFileId(panneId, tag);
  if (!fileId) {
    appStore.sendErrorNotice("Photo introuvable.");
    return;
  }

  const photoWindow = window.open("", "_blank");
  try {
    const fileUrl = await fetchFileContent(fileId);
    if (photoWindow) {
      photoWindow.location.href = fileUrl;
    } else {
      window.open(fileUrl, "_blank");
    }
  } catch (e) {
    photoWindow?.close();
    appStore.sendErrorNotice("Impossible d'ouvrir la photo.");
  }
}

async function openTicketPhoto(ticketId: string, tag: VaultFileTag): Promise<void> {
  const fileId = getTicketPhotoFileId(ticketId, tag);
  if (!fileId) {
    appStore.sendErrorNotice("Photo introuvable.");
    return;
  }

  const photoWindow = window.open("", "_blank");
  try {
    const fileUrl = await fetchFileContent(fileId);
    if (photoWindow) {
      photoWindow.location.href = fileUrl;
    } else {
      window.open(fileUrl, "_blank");
    }
  } catch (e) {
    photoWindow?.close();
    appStore.sendErrorNotice("Impossible d'ouvrir la photo.");
  }
}

async function downloadPannePhoto(panneId: string, tag: VaultFileTag): Promise<void> {
  const fileId = getPannePhotoFileId(panneId, tag);
  if (!fileId) {
    appStore.sendErrorNotice("Photo introuvable.");
    return;
  }

  try {
    const fileUrl = await fetchFileContent(fileId);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `panne-${panneId}-${tag.toLowerCase()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    appStore.sendErrorNotice("Impossible de télécharger la photo.");
  }
}

async function downloadTicketPhoto(ticketId: string, tag: VaultFileTag): Promise<void> {
  const fileId = getTicketPhotoFileId(ticketId, tag);
  if (!fileId) {
    appStore.sendErrorNotice("Photo introuvable.");
    return;
  }

  try {
    const fileUrl = await fetchFileContent(fileId);
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = `ticket-${ticketId}-${tag.toLowerCase()}.jpg`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (e) {
    appStore.sendErrorNotice("Impossible de télécharger la photo.");
  }
}

function findTicketById(ticketId: string): SupportTicket | null {
  for (const tickets of Object.values(openTicketPannesPerProduct.value)) {
    const foundTicket = tickets.find((item) => item.id === ticketId);
    if (foundTicket) {
      return foundTicket;
    }
  }

  return null;
}

function fileToDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}

function isPendingPanne(panne: Panne): boolean {
  return !!(panne.id && pendingPanneIds.value[panne.id]);
}

function addInstalledSparepart(panne: Panne): void {
  if (!panne.installedSpareParts) {
    panne.installedSpareParts = [];
  }

  panne.installedSpareParts.push({
    sparepartId: "",
    taskId: task.value.id,
    panneId: panne.id!,
    quantity: 1,
  });
}

function removeSubtask(subtask: Subtask): void {
  if (!task.value.subtasks) {
    task.value.subtasks = [];
  }

  task.value.subtasks = task.value.subtasks.filter((current) => current.id !== subtask.id);
}

function updateSubtask(subtask: Subtask): void {
  if (!task.value.subtasks) {
    task.value.subtasks = [];
  }

  const index = task.value.subtasks.findIndex((current) => current.id === subtask.id);
  if (index >= 0) {
    task.value.subtasks[index] = subtask;
  }
}

const sendEmail = async () => {
  try {
    await sendReport(task.value.id);
    appStore.sendSuccessNotice("Email envoyé avec succès");
  } catch (e) {
    appStore.sendErrorNotice("Erreur lors de l'envoi de l'email");
  }
};

function getIntervention(productId: string): Intervention | undefined {
  return interventions.value.find((i) => i.productId === productId);
}

function isInterventionCompleted(intervention: Intervention): boolean {
  return intervention.items.every((item) => {
    if (item.itemType === InterventionItemType.CHECKBOX) return item.completed;
    if (item.itemType === InterventionItemType.NUMERIC) return item.numericValue != null;
    if (item.itemType === InterventionItemType.TEXT) return item.textValue?.length > 0;
  });
}

async function completeIntervention(intervention: Intervention) {
  try {
    await putIntervention(intervention);
    appStore.sendSuccessNotice("Intervention sur le produit terminée avec succès");
  } catch (e) {
    // Ignore
  }
}

onBeforeUnmount(() => {
  Object.values(pannePhotoBeforeUrls.value).forEach((url) => URL.revokeObjectURL(url));
  Object.values(pannePhotoAfterUrls.value).forEach((url) => URL.revokeObjectURL(url));
  Object.values(ticketPhotoBeforeUrls.value).forEach((url) => URL.revokeObjectURL(url));
  Object.values(ticketPhotoAfterUrls.value).forEach((url) => URL.revokeObjectURL(url));
});
</script>

<style scoped>
.red-outline-wrapper ::v-deep(.v-field) {
  border-left: 4px solid red !important;
}

.green-outline-wrapper ::v-deep(.v-field) {
  border-left: 4px solid green !important;
}

.panne-thumbnail {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.panne-thumbnail-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.panne-thumbnail :deep(img) {
  object-fit: contain;
  object-position: center;
}

.ticket-thumbnail {
  width: 160px;
  height: 160px;
  cursor: pointer;
}

.ticket-thumbnail-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.ticket-thumbnail :deep(img) {
  object-fit: contain;
  object-position: center;
}
</style>
